import axios from "axios";

export const PROFESIONAL_URL = `Profesional`;

export const profesionalServices = {
  lookup: (queryParams: any) => {
    return axios.get<any>(`${PROFESIONAL_URL}/Lookup`, {
      params: {
        ...queryParams,
      },
    });
  },
};
